import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "as", "children", "className", "content", "css", "onOpenChange", "showArrow", "isOpen", "preferredSide", "preferredAlignment", "style"];
import React from "react";
import BaseTooltip from "./BaseTooltip";
import { jsx as _jsx } from "react/jsx-runtime";
function Tooltip(_ref) {
  var ariaLabel = _ref.ariaLabel,
    as = _ref.as,
    children = _ref.children,
    className = _ref.className,
    content = _ref.content,
    css = _ref.css,
    onOpenChange = _ref.onOpenChange,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
    isOpen = _ref.isOpen,
    _ref$preferredSide = _ref.preferredSide,
    preferredSide = _ref$preferredSide === void 0 ? "top" : _ref$preferredSide,
    _ref$preferredAlignme = _ref.preferredAlignment,
    preferredAlignment = _ref$preferredAlignme === void 0 ? "center" : _ref$preferredAlignme,
    style = _ref.style,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseTooltip, _extends({
    showArrow: showArrow,
    content: content,
    ariaLabel: ariaLabel,
    onOpenChange: onOpenChange,
    isOpen: isOpen,
    preferredSide: preferredSide,
    preferredAlignment: preferredAlignment
  }, restProps, {
    children: children
  }));
}
export default Tooltip;